<template>
  <div>
    <div class="right-title">
      <span>职位列表</span>
    </div>
    <div class="content-box">
      <div class="search-box">
        <div class="shaixuan">
          筛选：
          <a href="javascript:void 0" @click="listOrders('')" :class="{'active':listOrder === ''}">默认</a>
          <a href="javascript:void 0" @click="listOrders(1)" :class="{'active':listOrder === 1}">阅读量</a>
          <a href="javascript:void 0" @click="listOrders(2)" :class="{'active':listOrder === 2}">投递量</a>
          <a href="javascript:void 0" @click="listOrders(3)" :class="{'active':listOrder === 3}">面试量</a>
          <a href="javascript:void 0" @click="listOrders(4)" :class="{'active':listOrder === 4}">推荐量</a>
        </div>
        <el-input
          class="search"
          type="text"
          placeholder="请输入职位ID/名称"
          v-model="search"
        >
        </el-input>
        <el-button class="btn2" @click="keyWord" type="primary">搜索</el-button>
      </div>
      <div class="tab-box">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%;height: 100%"
          :header-cell-style="{background: '#f2f3f5',colori: '#000;'}"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            fixed
            type="selection"
            v-if="user.admin_type !== 1"
            width="55">
          </el-table-column>
          <el-table-column
            prop="id"
            label="ID"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="jobs_name"
            label="职位标题"
            align="center"
          >
            <template slot-scope="scope">
              <span style="color: #00a2ea;cursor: pointer;"
                    @click="toDetail(scope.row.id)">{{scope.row.jobs_name}}</span>
            </template>
          </el-table-column>
          <!--          <el-table-column-->
          <!--                  prop="name"-->
          <!--                  label="职位类型"-->
          <!--                  align="center"-->
          <!--          >-->
          <!--          </el-table-column>-->
          <el-table-column
            prop="organization_name"
            label="发布机构"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span style="cursor: pointer;"
                    @click="toOrg(scope.row.organization_id)">{{scope.row.organization_name}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="status"
            label="职位状态"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span >{{scope.row.status | status}}</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="read_count"
            label="阅读量"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span >{{scope.row.read_count}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="resume_count"
            label="投递(简历)数量"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span >{{scope.row.resume_count}}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="interview_count"
            label="面试数量"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span >{{scope.row.interview_count}}</span>
            </template>
          </el-table-column>






          <el-table-column
            prop="recommendCount"
            label="职位推荐数量"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.recommendCount === 0">{{scope.row.recommendCount}}</span>
              <span v-else @click="toRecommendCount(scope.row.id)" style="color: #00a2ea;cursor: pointer;">{{scope.row.recommendCount}}</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="create_time"
            label="发布时间"
            align="center"
            show-overflow-tooltip>
            <template slot-scope="scope">
              <span>{{scope.row.create_time}}</span>
            </template>
          </el-table-column>
          <el-table-column
              prop="create_time"
              label="操作"
              align="center"
              show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button v-if="scope.row.status === 0" @click="xiaxian(scope.row)">下线</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="page-box">
          <div>
<!--            <el-button type="danger" @click="deleteList">删除</el-button>-->
            共计{{page.pageTotal}}条，已上线{{real_count}}条，未上线{{page.pageTotal- real_count}}条
            <el-button type="primary" @click="addForm" v-if="user.admin_type !== 1">添加到表单</el-button>
          </div>
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="page.pageNum"
            :page-size="page.pageSize"
            layout="prev, pager, next, jumper"
            :total="page.pageTotal">
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="选择表单" :visible.sync="dialogFormVisible" append-to-body>
      <el-form :model="form">
        <el-form-item label="选择列表">
          <el-select v-model="form.region" placeholder="请选择表单列表">
            <el-option
              v-for="item in fList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addFormSub">确 定</el-button>
      </div>
    </el-dialog>
    <footerBox class="footer"/>
  </div>
</template>

<script>
  import footerBox from '../components/rightBottom'

  export default {
    name: "zwList",
    data() {
      return {
        search: '',  // 搜索
        listOrder:'',
        tableData: [],
        multipleSelection: [], //  选中的
        page: {
          pageNum: 1,
          pageSize: 10,
          pageTotal: 1
        },
        real_count:0,
        formList: [],  // 表单数据
        form: {
          region: '',
          name: ''
        },
        dialogFormVisible: false
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      },
      fList() {
        let flist = JSON.parse(JSON.stringify(this.formList))
        flist.map(item => {
          item.label = item.name
          item.value = item.id

        })
        return flist
      },
    },
    created() {
      this.$emit('setType', 0)
      this.wzList()
    },
    methods: {
      //  操作职位下线
      xiaxian(obj){
        this.$prompt('请输入下线原因', '职位下线', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        }).then(({ value }) => {
          if(!value){
            console.log(value)
            this.$message.error('请输入下线原因')
            return
          }
          this.$api.apiContent.zwDown({
            admin_id: this.user.id,
            id:obj.id,
            delContent:value
          }).then(()=>{
            this.$message.success('操作成功')
            this.wzList()
          }).catch(e=>{
            this.$message.error(e.info)
          })
        }).catch(() => {

        });
      },


      // 职位列表
      wzList() {
        const loading = this.$loading({
          target: this.$refs.listBox,
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0.7)'
        });
        if (this.$route.query.pageNum) {
          this.page.pageNum = Number(this.$route.query.pageNum)
        } else {
          this.page.pageNum = 1
        }
        if (this.$route.query.key) {
          this.search = this.$route.query.key
        } else {
          this.search = ''
        }
        if (this.$route.query.listOrder) {
          this.listOrder = Number(this.$route.query.listOrder)
        } else {
          this.listOrder = ''
        }

        this.$api.apiContent.zwList({
          search: this.search,
          page: this.page.pageNum,
          pageSize: this.page.pageSize,
          admin_id: this.user.id,
          listOrder:this.listOrder
        }).then(res => {
            loading.close();
          this.page.pageNum = res.now_page
          this.page.pageTotal = res.total_number
          res.data.map(item => {
            item.create_time = this.$tools.ZHDate(new Date(item.create_time * 1000), 1)
            //推荐
            item.commend = item.commend === 0 ? (true) : (false)
          })
          this.tableData = res.data
          this.real_count = res.real_count
        }).catch(() => {
            loading.close();
          this.tableData = []
          this.page.pageTotal = 0
        })

      },
      keyWord() {     //  搜索
        if(this.page.pageNum === 1){
          this.setPath()
        }else{
          this.page.pageNum = 1
        }
      },
      listOrders(num){
        if(this.listOrder === num){
          return
        }else{
          this.listOrder = num
          this.page.pageNum = 1
          this.setPath()
        }
      },
      handleSizeChange(num) {        //  点击分页
        this.page.pageNum = num
      },
      handleCurrentChange(num) {     //  选择页数
        this.page.pageNum = num
      },
      //  推荐到首页
      tuiJian(id,type) {
        let num = type?1:0
        let messg = ""
        if (type) {
          messg = "此操作将不推荐到首页, 是否继续?"
        } else {
          messg = "此操作将推荐到首页, 是否继续?"
        }
        this.$confirm(messg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$api.apiContent.zwCommend({
            jobId: id,
            commend: num,
            adminId: this.user.id
          }).then(res => {
            this.$message({
              type: 'success',
              message: res.info
            });
            this.wzList()
          }).catch(res => {
            this.$message.error(res.info);
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      //  去机构详情
      toOrg(id){
        this.$router.push('/home/jgAdmin/jgDetail/' + id)
      },
      //  去职位详情
      toDetail(id){
        this.$router.push('/home/zwAdmin/zwDetail/' + id)
      },
      toRecommendCount(id){
        this.$router.push('/home/zwAdmin/zwaddList/' + id)
      },
      //  修改路径
      setPath() {
        this.$router.push({
          path: '/home/zwAdmin/zwList',
          query: {
            pageNum: this.page.pageNum,
            key: this.search,
            listOrder:this.listOrder
          }
        })
      },
      //  列表选中存入数据
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      //  删除选中的
      deleteList() {
        console.log(this.multipleSelection)
        if (this.multipleSelection.length > 0) {
          let len = this.multipleSelection.length
          this.$confirm('此操作将删除该信息, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            let _arr = []
            this.multipleSelection.map(item => {
              _arr.push(item.id)
            })
            this.$api.apiContent.jgZhiwdel({
              id: _arr.join(","),
              admin_id: this.user.id
            }).then(res => {
              if (this.page.pageNum > 1 && len === this.list.length) {
                this.page.pageNum = this.page.pageNum - 1
              } else {
                this.wzList()
              }
              this.$message({
                type: 'success',
                message: res.info
              });
              this.$refs.multipleTable.clearSelection();
            }).catch(res => {
              this.$message.error(res.info);
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
        } else {
          this.$message.error("请选中要删除的数据！");
        }
      },
      // 表单表单列表
      addForm() {
        if (this.multipleSelection.length > 0) {
          this.dialogFormVisible = true
          this.$api.apiContent.hxrAddFormList({
            type: 3,
            admin_id: this.user.id
          }).then(res => {
            this.formList = res.data
          }).catch(res => {
            this.$message.error(res.info);
          })
        } else {
          this.$message.error('请选择要添加的数据');
        }
      },
      // 添加到表单
      addFormSub() {
        this.dialogFormVisible = false
        let arrId = []
        this.multipleSelection.map(item => {
          arrId.push(item.id)
        })
        this.$api.apiContent.hxrAddForm({
          formid: this.form.region,
          id: arrId.join(','),
          admin_id: this.user.id,
        }).then(res => {
          this.$message.success(res.info);
          this.$refs.multipleTable.clearSelection();
        }).catch(res => {
          this.$message.error(res.info);
        })
      },
    },
    watch: {
      'page.pageNum'() {
        this.setPath()
      },
      $route() {
        this.wzList()
      }
    },
    filters:{
      status(val){
        switch (Number(val)) {
          case 0:
            return '正常'
          case 1:
            return '手动下线'
          case 2:
            return '自动下线'
          case 3:
            return '不信任下线'
          case 4:
            return '审核中下线'
        }
      }
    },
    components: {
      footerBox
    }
  }
</script>

<style scoped lang="scss">
  .search-box {
    position: absolute;
    top: 10px;
    left: 10px;
    right: 10px;
    z-index: 1;
    display: flex;
    justify-content: flex-end;
    .shaixuan{
      position: absolute;
      top: 0;
      right: 340px;
      height: 40px;
      line-height: 40px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      a{
        color: #333;
        margin: 0 10px;
        &.active{
          color: #00a2ea;
        }
      }
    }

    .search {
      width: 220px;
      position: absolute;
      right: 80px;
      border-radius: 4px !important;
    }

    .btn {
      position: absolute;
      left: 0px;
      padding: 10px 40px;
    }
  }

  .tab-box {
    position: relative;
    /*top: 64px;*/
    /*left: 10px;*/
    /*right: 10px;*/
    /*bottom: 60px;*/
    min-height: 100%;
    padding-top: 50px;
    padding-bottom: 60px;
    background: #fff;


    .page-box {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 60px;
      padding: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }

</style>